<div class="next-aztec-scanner-introduction">
  <div class="next-aztec-scanner-introduction__title">
    {{ getTranslationKey('TITLE') | translate }}
  </div>

  <div class="next-aztec-scanner-introduction__subtitle"
       [innerHTML]="getTranslationKey('SUBTITLE') | translate | safeHtml">
  </div>

  <div class="next-aztec-scanner-introduction__image">
    <img src="./assets/images/aztec-scanner-info.webp"
         alt="">
  </div>

  <div class="next-aztec-scanner-introduction__buttons">
    <button class="btn"
            (click)="scan()">
      {{ getTranslationKey('SCAN') | translate }}
    </button>

    <button class="btn btn--outline"
            (click)="cancel()">
      {{ getTranslationKey('CANCEL') | translate }}
    </button>
  </div>
</div>
